import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_shipping_price_book_line_RowClass} from '../../../dbschema';

export class ShippingPriceBookLineContainerModel extends BaseContainerModel {
  bl_fi_mst_shipping_price_book_line: bl_fi_mst_shipping_price_book_line_RowClass = new bl_fi_mst_shipping_price_book_line_RowClass();
}
